export const LOADING = "loader";
export const LANGUAGE = "language";
